export enum QuestionType {
  CHECK = 'check',
  RADIO = 'radio',
  FREE = 'free',
}
